import {api} from '../../api/access-ctrl'
import {registerConfig} from '../../../components/common/di-ding'
import {commonConfig, routeNameOfDi} from '../common'
import {spDateFormat} from '../../../utils/util'
import inputDateHelper from '../../../components/common/inputs/_input-date-helper'

const mapping = {
  deviceName: {
    label: '设备名称'
  },
  deviceCode: {
    label: '设备编号'
  },
  deviceChangeStatus: {
    label: '设备状态变更',
    mapList: {
      map: {
        '0': '在线-->离线',
        '1': '离线-->在线'
      }
    }
  },
  changeTime: {
    label: '状态变更时间'
  }
}

const config = {
  breadcrumb: [{
    value: '智慧门禁',
    name: 'accessCtrlDeviceManagementCenter'
  }, {
    value: '状态日志',
  }],
  center: {
    opBar: [ // 多少个元素代表多少行
      [ // 仅支持 flex布局
        {
          type: 'date-second',
          pickerOptions: {
            shortcuts: [
              inputDateHelper.OPTIONS.SHORTCUT.A_WEEK,
              inputDateHelper.OPTIONS.SHORTCUT.A_MONTH,
              inputDateHelper.OPTIONS.SHORTCUT.THREE_MONTHS
            ],
            disabledDate: inputDateHelper.OPTIONS.DISABLED_DATE.HENCEFORTH
          },
          default: inputDateHelper.time.todayRange,
          beforeDataIsGet ({requestBody}) {
            const [startTime, endTime] = inputDateHelper.time.todayRange()
            requestBody.startTime = spDateFormat(startTime)
            requestBody.endTime = spDateFormat(endTime)
          },
          entityInSearchRequestBody: (currentTime) => ({
            startTime: currentTime[0]||'',
            endTime: currentTime[1]||''
          })
        },
        {
          type: 'search-selector',
          label: '设备状态变更',
          searchKey: 'deviceChangeStatus',
          fetchDetail: () => Promise.resolve(
            [{
              '_value': '0',
              '_label': '在线-->离线'
            }, {
              '_value': '1',
              '_label': '离线-->在线'
            }]
          )
        },
        [
          {type: 'input-search', label: '设备名称/设备编号', searchKey: 'searchKey'},
          {
            type: 'button-download',
            label: '导出',
            getDownloadUrl: (requestBody) => api.exportAccessDeviceStatus(requestBody),
            download: '开门记录'
          }
        ]
      ]
    ],
    table: {
      operations: []
    }
  },

  get: requestBody => api.getAccessDeviceStatusPage(requestBody),

  mapping
}

registerConfig(routeNameOfDi.APP_CENTER_ACCESS_CTRL_DEVICE_STATUS, config)



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/device-status/device-status.js